import React, { useState, useEffect } from "react";
import Pagination from '../../../../components/pagination/Pagination.jsx';
import columns from "../../../../columns/ib/MT5Account/MT5AcceptedAccounts.js";
import TableWithSkeleton from '../../../../components/table/TableWithSkeleton.jsx';
import { GetAllAccountApi, GetAllV2fxAccountByIdApi } from '../../../../api/request/liveAccount.js';
import ModalComponent from '../../../../components/modals/ModalComponent.jsx';
import moment from "moment";
import Eye from "../../../../assets/Eye.jsx";
import { Spin } from 'antd';

export default function AcceptedAccounts({ searchText }) {
  const [isLoading, setIsLoading] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState([]);
  const [totalRecord, setTotalRecord] = useState(0);
  const [data, setData] = useState([]);
  const [selectedV2fxId, setSelectedV2fxId] = useState('');
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [V2fxDetails, setV2fxDetails] = useState({});
  const [isUserLoading, setIsUserLoading] = useState(false);
  const [sorter, setSorter] = useState({ SortBy: 'createdDate', SortOrder: '' });

  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter?.order) {
      setSorter({ SortBy: sorter?.field, SortOrder: sorter?.order });
    } else {
      setSorter({ SortBy: 'createdDate', SortOrder: '' });
    }
  };

  const getApprovedAccounts = async () => {
    try {
      let params = {
        PageNumber: page,
        PageSize: pageSize,
        SearchText: searchText,
        FilterText: "Approved",
        ...sorter
      }
      setIsLoading(true);
      const { data } = await GetAllAccountApi(new URLSearchParams(params).toString());
      if (data?.success) {
        setData(
          data?.data?.map((item) => {
            return {
              ...item,
              name: `${item?.firstName} ${item?.lastName}`,
              createdDate: (item?.createdDate ? moment(item?.createdDate).format("DD-MM-YYYY, hh:mm A") : null),
              balance: `$ ${item?.balance}`,
              actions: (
                <div className="flex">
                  <button type="button" onClick={() => { setSelectedV2fxId(item?.terminalID); setIsOpenModal(true) }}><Eye /></button>
                </div>
              ),
            };
          })
        );
        setTotalRecord(data?.totalRecords);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getApprovedAccounts();
  }, [page, pageSize, searchText, filter, sorter]);

  const getV2fxById = async () => {
    try {
      setIsUserLoading(true);
      const { data } = await GetAllV2fxAccountByIdApi(selectedV2fxId);
      setV2fxDetails(data?.data);
      setIsUserLoading(false);
    } catch (error) { }
  }

  useEffect(() => {
    if (selectedV2fxId) {
      getV2fxById();
    }
  }, [selectedV2fxId]);

  return (
    <div>
      <div className="w-full my-6">
        <div className="border border-gray-200 rounded-xl">
          <TableWithSkeleton columns={columns} data={data} loading={isLoading} onChange={handleTableChange} />
        </div>
        <Pagination total={totalRecord} page={page} setPage={setPage} pageSize={pageSize} setPageSize={setPageSize} />
      </div>

      {/* ---- V2fx Account Information ---- */}
      <ModalComponent isOpen={isOpenModal} setIsOpen={setIsOpenModal} title='V2fx Account Information' width={1300}>
        <div className='p-5'>
          {
            isUserLoading ? (
              <div className="flex justify-center flex-col my-[10%]">
                <Spin size="large" />
                <p className="primary text-center mt-2">Loading...</p>
              </div>
            ) : (
              <div className='grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-10 '>
                <div>
                  <p className='text-base font-normal '>Full Name</p>
                  <p className='text-xl primary font-semibold  mt-2'>{V2fxDetails?.fullName || "--"}</p>
                </div>
                <div>
                  <p className='text-base font-normal '>Account No.</p>
                  <p className='text-xl primary font-semibold  mt-2'>{V2fxDetails?.id || "--"}</p>
                </div>
                <div>
                  <p className='text-base font-normal '>Country</p>
                  <p className='text-xl primary font-semibold  mt-2'>{V2fxDetails?.country || "--"}</p>
                </div>
                <div>
                  <p className='text-base font-normal '>Balance</p>
                  <p className='text-xl primary font-semibold  mt-2'>$ {V2fxDetails?.balance || "0"}</p>
                </div>
                <div>
                  <p className='text-base font-normal '>Leverage</p>
                  <p className='text-xl primary font-semibold  mt-2'>{V2fxDetails?.leverage || "0"}</p>
                </div>
                <div>
                  <p className='text-base font-normal '>Group</p>
                  <p className='text-xl primary font-semibold  mt-2'>{V2fxDetails?.groupName || '--'}</p>
                </div>
                {V2fxDetails?.status && <div>
                  <p className='text-base font-normal '>Status</p>
                  <p className='text-xl primary font-semibold  mt-2'>{V2fxDetails?.status || '--'}</p>
                </div>}
              </div>
            )
          }
        </div>
      </ModalComponent>
    </div>
  )
}

